/* Maison Saint-Honoré — galerie produit filtrée par coloris.
 * Toutes les photos sont rendues ; chaque photo « coloris X » est rattachée à son coloris
 * (carte JSON dans la galerie). Le script masque les photos des autres coloris
 * dans la galerie, les vignettes et la visionneuse, au chargement et à chaque changement. */
(function () {
  if (window.mshColorGallery2) return;
  window.mshColorGallery2 = true;

  function galleries() {
    return document.querySelectorAll('media-gallery[data-msh-color-filter]');
  }

  function mapOf(gallery) {
    try {
      return JSON.parse(gallery.querySelector('[data-msh-color-map]').textContent) || {};
    } catch (e) {
      return {};
    }
  }

  function idFrom(value) {
    return value ? String(value).split('-').pop() : '';
  }

  function knownColors() {
    var known = {};
    galleries().forEach(function (g) {
      var map = mapOf(g);
      Object.keys(map).forEach(function (k) {
        if (map[k]) known[map[k]] = true;
      });
    });
    return known;
  }

  function currentColor() {
    var known = knownColors();
    var inputs = document.querySelectorAll('variant-selects input[type="radio"]:checked, variant-selects select');
    for (var i = 0; i < inputs.length; i++) {
      if (known[inputs[i].value]) return inputs[i].value;
    }
    var g = document.querySelector('media-gallery[data-msh-color-filter]');
    return g ? g.getAttribute('data-msh-selected-color') : null;
  }

  function apply() {
    var color = currentColor();
    if (!color) return;
    galleries().forEach(function (g) {
      var map = mapOf(g);
      var visible = 0;
      g.setAttribute('data-msh-selected-color', color);

      g.querySelectorAll('li[data-media-id]').forEach(function (li) {
        var c = map[idFrom(li.dataset.mediaId)];
        var hide = !!c && c !== color;
        li.classList.toggle('msh-hidden', hide);
        if (!hide) visible++;
      });

      g.querySelectorAll('li[data-target]').forEach(function (li) {
        var c = map[idFrom(li.dataset.target)];
        li.classList.toggle('msh-hidden', !!c && c !== color);
        li.classList.remove('thumbnail-list_item--variant');
      });

      var total = g.querySelector('.slider-counter--total');
      if (total) total.textContent = visible;

      document.querySelectorAll('.product-media-modal__content [data-media-id]').forEach(function (el) {
        var c = map[idFrom(el.dataset.mediaId)];
        el.classList.toggle('msh-hidden', !!c && c !== color);
        el.classList.remove('product__media-item--variant');
      });

      var active = g.querySelector('ul.product__media-list li.is-active[data-media-id]');
      if (!active || active.classList.contains('msh-hidden')) {
        var first = g.querySelector('ul.product__media-list li[data-media-id]:not(.msh-hidden)');
        if (first && typeof g.setActiveMedia === 'function') g.setActiveMedia(first.dataset.mediaId, true);
      }
    });
  }

  function later() {
    apply();
    setTimeout(apply, 300);
    setTimeout(apply, 1000);
  }

  function init() {
    apply();
    document.addEventListener('change', function (event) {
      if (event.target && event.target.closest && event.target.closest('variant-selects')) later();
    });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () {
        later();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
